<template>
  <v-textarea
      :id="control.uniqueId"
      type="text"
      :class="controlFieldClass"
      v-model="inputModel"
      dense
      :disabled="isDisabled"
      :rows="control.rows"
      :name="control.name || control.uniqueId"
      :placeholder="control.placeholderText"
      @input="updateValue(inputModel)"/>

</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {readUserProfile} from '@/store/main/getters';

export default {
  name: 'TextAreaCustomControl',
  extends: BaseControlSkeleton,
  data: () => ({
    inputModel: null,
    isDisabled: false,
  }),
  async mounted() {
    if (this.control.disableByRoleSetting) {
      const userProfile = readUserProfile(this.$store);
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    if (!this.value) {
      await Promise.all([
        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
        this.updateValue(this.value),
        this.inputModel = this.value,
      ]);
    }
  },
};
</script>

<style scoped>

</style>
